import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    TextField,
    Typography,
} from "@mui/material";
import { Save, Description } from "@mui/icons-material";
import { WB_SX, WB_UI } from "../../../ui/ux/uiTokens";

/**
 * Quick update for WhatsApp business description only.
 * POST .../business-profile/description
 */
const ProfileDescriptionCard = ({
    initialDescription = "",
    onSave,
    loading = false,
}) => {
    const [description, setDescription] = useState(initialDescription || "");

    useEffect(() => {
        setDescription(initialDescription || "");
    }, [initialDescription]);

    const handleSave = () => {
        const value = description.trim();
        if (!value) return;
        onSave?.(value);
    };

    return (
        <Card elevation={0} sx={{ ...WB_SX.card, height: "100%" }}>
            <CardContent sx={WB_SX.cardContent}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                    <Box
                        sx={{
                            width: 36,
                            height: 36,
                            borderRadius: 1.5,
                            display: "grid",
                            placeItems: "center",
                            backgroundColor: WB_UI.color.softInfoBg,
                            color: WB_UI.color.primaryButtonBg,
                            border: `1px solid ${WB_UI.color.border}`,
                        }}
                    >
                        <Description fontSize="small" />
                    </Box>
                    <Box>
                        <Typography variant="subtitle2" sx={WB_SX.sectionTitle}>
                            Update Description
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Convenience API — updates description only (max 512 chars)
                        </Typography>
                    </Box>
                </Box>

                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label="Business Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    helperText={`${description.length}/512`}
                    inputProps={{ maxLength: 512 }}
                    sx={{ mb: 2 }}
                />

                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                        variant="contained"
                        startIcon={<Save />}
                        onClick={handleSave}
                        disabled={loading || !description.trim()}
                        sx={WB_SX.primaryButton}
                    >
                        Save Description
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
};

export default ProfileDescriptionCard;
